<div class="chatter-freeform">
    <div class="chatter-freeform__field-container">
        <input #input type="text" (keyup.enter)="handleFreeformSelection()"/>
    </div>
</div>